import { Container } from '@raskrask-dk/rr-components'
import { ReactElement, ReactNode } from 'react'
import { BackButton } from '..'
import { Overlapper, StyledPageTemplate } from './styles'

export interface PageTemplateProps {
    Top: ReactNode
    Body: ReactNode
    Modal: ReactNode
    bodyOverlap?: boolean
    onClickBack?: () => void
    hideBackButton?: boolean
}

export const PageTemplate = ({
    Top,
    Body,
    Modal,
    bodyOverlap,
    onClickBack,
    hideBackButton,
}: PageTemplateProps): ReactElement => (
    <StyledPageTemplate>
        <BackButton onClickBack={onClickBack} hideBackButton={hideBackButton} />
        {Top && (
            <Container background="$primary200" css={{ py: Top ? '$3' : 0 }}>
                {Top}
                {bodyOverlap && <Overlapper css={{ h: 200 }} />}
            </Container>
        )}
        {Body && (
            <Container>
                <Overlapper css={{ mt: bodyOverlap ? -200 : 0, bgc: '$white' }}>
                    {Body}
                </Overlapper>
            </Container>
        )}
        {Modal}
    </StyledPageTemplate>
)
